import { render, staticRenderFns } from "./RegistryActionLinks.vue?vue&type=template&id=3144757f&scoped=true"
import script from "./RegistryActionLinks.vue?vue&type=script&lang=js"
export * from "./RegistryActionLinks.vue?vue&type=script&lang=js"
import style0 from "./RegistryActionLinks.vue?vue&type=style&index=0&id=3144757f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3144757f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3144757f')) {
      api.createRecord('3144757f', component.options)
    } else {
      api.reload('3144757f', component.options)
    }
    module.hot.accept("./RegistryActionLinks.vue?vue&type=template&id=3144757f&scoped=true", function () {
      api.rerender('3144757f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/registry/RegistryActionLinks.vue"
export default component.exports